import * as api from './base';

export const index = (params) => api.get({
    url: "Index/Index",
    params,
    loading: "加载中"
});

